import {
  CHANGE_DELIVERY,
  CLEAR_CART,
  CUSTOMER_ADDRESS,
  CUSTOMER_ADDRESS_ALL,
  CUSTOMER_ADDRESS_DISCARD,
  CUSTOMER_DELETE_ADDRESS,
  CUSTOMER_EDIT_ADDRESS,
  DELIVERY_ADDRESS,
  DELIVERY_MENU,
  DELIVERY_SLOT,
  DELIVERY_TYPE_MENU,
  SELECT_STORE,
  SUMMARY_DELIVERY,
  STORE_CLOSE_WARNING,
  SUMMARY_REORDER_DELIVERY,
  DIFFERENT_STORE_TYPE,
  SELECT_STORE_DIFFERENT_STORE_TYPE,
  DELIVERY_TYPE_MENU_DIFFERENT_STORE_TYPE,
  SUMMARY_CONTACT,
  CHANGE_STORE_DIALOG,
  REORDER,
  REORDER_CLEAR_CART,
  SELECT_STORE_TYPE,
  STORE_WITH_OUT_AREA,
  REDIRECT_TO_B2B,
  REDIRECT_TO_B2B_CLUB_PACK,
  TERMS_AND_CONDITION_INSTALLMENT
} from '../../constant/deliveryFlow';
import DeliveryMenu from './components/DeliveryMenu';
import SelectDeliveryType from './components/SelectDeliveryType';
import DeliveryAddress from './components/PreOrder/HomeDelivery/DeliveryAddress';
import StoreLocation from './components/PreOrder/ClickAndCollect/StoreLocation';
import DeliverySummary from './components/DeliverySummary';
import ChangeDeliveryDialog from './components/ChangeDeliveryDialog';
import SlotBooking from './components/PreOrder/ClickAndCollect/SlotBooking';
import ClearCartDialog from './components/ClearCartDialog';
import DifferentStoreTypeDialog from './components/DifferentStoreTypeDialog';
import {
  CustomerDeleteAddress,
  CustomerManageAddress,
  CustomerSelectAddress,
  CustomerViewAllAddress,
} from './components/CustomerAddress';
import configuration from '../../configs/configuration';
import CustomerDiscardAddress from './components/CustomerAddress/CustomerDiscardAddress';
import StoreCloseWarningDialog from './components/StoreCloseWarningDialog';
import DeliveryReOrderSummary from './components/DeliveryReOrderSummary';
import SummaryContact from './components/SummaryContact';
import ChangeCartStoreDialog from './components/ChangeCartStoreDialog';
import ReorderDialog from './components/ReorderDialog';
import ReorderClearCartDialog from './components/ReorderClearCartDialog';
import SelectStoreType from './components/SelectStoreType';
import StoreWithoutArea from './components/StoreViewOutArea';
import { goToPath } from '../../utils/useLocationPath';
import urlResolver from '../../constant/urlPattern';
import TermsAndConditionInstallment from './components/TermsAndConditionInstallment';

export default {
  [DELIVERY_MENU]: {
    name: DELIVERY_MENU,
    Component: DeliveryMenu,
    nextPage: (state, data, { formControl, storeTime }) => {
      const nextPage = {
        OD: DELIVERY_ADDRESS,
        SFL: DELIVERY_TYPE_MENU
      };
      const { activeData } = state;

      if (data === 'OD') {
        formControl.updateForm('delivery', { deliveryType: 'OD', deliveryMethod: 'HD' });
        if (activeData.delivery.deliveryType === 'SFL') {
          if (storeTime.isClose) {
            return STORE_CLOSE_WARNING;
          }
          return CHANGE_DELIVERY;
        }

        if (state.completedForm || state.formHadData) {
          return SUMMARY_DELIVERY;
        }

        if (storeTime.isClose) {
          return STORE_CLOSE_WARNING;
        }
      } else {
        formControl.updateForm('delivery', { deliveryType: 'SFL', deliveryMethod: '' });
        if (activeData.delivery.deliveryType === 'OD') {
          return CHANGE_DELIVERY;
        }
      }
      return nextPage[data];
    },
    backPage: '',
    onClose: (state, { formControl }) => {
      const { activeData, completedForm } = state;
      if (completedForm) {
        formControl.updateForm('delivery', { ...activeData.delivery });
      }
    }
  },
  [DELIVERY_TYPE_MENU]: {
    name: DELIVERY_TYPE_MENU,
    Component: SelectDeliveryType,
    nextPage: (state, data, { authentication, formControl, modalControl, storeTime }) => {
      const { activeData, formData, storeWithoutArea, startB2BActive } = state;
      const deliveryCode = `${activeData.delivery.deliveryType}.${activeData.delivery.deliveryMethod}`;
      const shouldShowSummary = ((state.completedForm || state.formHadData) && !state?.fromDifferentStoreType && !state.fromWidget);
      const changeMethod = _.get(storeWithoutArea, 'changeMethod', false);
      const { siteCode } = configuration;

      localStorage.setItem('dumpDl', JSON.stringify(data));
      if (startB2BActive && siteCode === 'TH') {
        formControl.setRedirectTo(REDIRECT_TO_B2B_CLUB_PACK);
      }

      if (siteCode === 'MY') {
        formControl.updateForm('delivery', { deliveryType: 'SFL', deliveryMethod: `${data}` });
      } else {
        if (data.includes('OD')) {
          if (storeTime.isClose) {
            return STORE_CLOSE_WARNING;
          }
          formControl.updateForm('delivery', { deliveryType: 'OD', deliveryMethod: 'HD' });
        } else {
          formControl.updateForm('delivery', { deliveryType: 'SFL', deliveryMethod: `${data}ND` });
        }
      }
      if (data === 'HD') {
        if (deliveryCode.includes('SFL.HLE') && !state.fromWidget) {
          modalControl.setPendingDeliverySetting('SFL.HDND');
          return CHANGE_STORE_DIALOG;
        }
        if (deliveryCode.includes('SFL.B2B') && !state.fromWidget) {
          modalControl.setPendingDeliverySetting('SFL.HDND');
          return CHANGE_STORE_DIALOG;
        }
        if (deliveryCode.includes('SFL.B2B') && !state.fromWidget) {
          modalControl.setPendingDeliverySetting('SFL.HDND');
          return CHANGE_STORE_DIALOG;
        }
        if (deliveryCode.includes('SFL.CC') || deliveryCode.includes('OD.HD')) {
          return CHANGE_DELIVERY;
        }
        if (shouldShowSummary) {
          return SUMMARY_DELIVERY;
        }
        if ((state?.fromDifferentStoreType && formData?.shippingAddress?.isDefault) || formData?.shippingAddress?.isDefault) {
          return SELECT_STORE;
        }
        if (changeMethod && authentication?.isGuest) {
          return SELECT_STORE;
        }
        return authentication?.isGuest ? DELIVERY_ADDRESS : CUSTOMER_ADDRESS;
      }
      if (data.includes('OD')) {
        if (deliveryCode.includes('SFL')) {
          if (state?.fromDifferentStoreType) {
            if (formData?.shippingAddress?.isDefault) {
              return SELECT_STORE;
            }
            return authentication?.isGuest ? DELIVERY_ADDRESS : CUSTOMER_ADDRESS;
          }
          return CHANGE_DELIVERY;
        }
        if (changeMethod) {
          return SELECT_STORE;
        }
        if (shouldShowSummary && !startB2BActive) {
          return SUMMARY_DELIVERY;
        }
        if (state?.fromDifferentStoreType || data.includes('go_fresh') || data.includes('hyper')) {
          if (formData?.shippingAddress?.isDefault) {
            return SELECT_STORE;
          }
          return authentication?.isGuest ? DELIVERY_ADDRESS : CUSTOMER_ADDRESS;
        }
        return SELECT_STORE_TYPE;
      }

      if (deliveryCode.includes('SFL.HLE') && !state.fromWidget) {
        modalControl.setPendingDeliverySetting('SFL.CCND');
        return CHANGE_STORE_DIALOG;
      }
      if (deliveryCode.includes('SFL.B2B') && startB2BActive) {
        modalControl.setPendingDeliverySetting('SFL.CCND');
        return SELECT_STORE;
      }
      if (deliveryCode.includes('SFL.B2B') && !state.fromWidget) {
        modalControl.setPendingDeliverySetting('SFL.CCND');
        return CHANGE_STORE_DIALOG;
      }
      if (deliveryCode.includes('SFL.B2B') && !state.fromWidget) {
        modalControl.setPendingDeliverySetting('SFL.CCND');
        return CHANGE_STORE_DIALOG;
      }
      if (deliveryCode.includes('SFL.HD') || (deliveryCode.includes('OD.HD') && !data.includes('OD'))) {
        return CHANGE_DELIVERY;
      }
      if (shouldShowSummary && !startB2BActive) {
        return SUMMARY_DELIVERY;
      }

      return SELECT_STORE;
    },
    backPage: (state, { formControl }) => {
      const { activeData, completedForm } = state;
      if (completedForm) {
        formControl.updateForm('delivery', { ...activeData.delivery });
      }
    },
    onClose: (state, { formControl }) => {
      const { activeData, completedForm } = state;
      if (completedForm) {
        formControl.updateForm('delivery', { ...activeData.delivery });
      }
    }
  },
  [SELECT_STORE_TYPE]: {
    name: SELECT_STORE_TYPE,
    Component: SelectStoreType,
    nextPage: (state, data, { formControl }) => {
      formControl.updateForm('delivery', { deliveryType: 'OD', deliveryMethod: 'HD' });
      formControl.updateForm('filter', { storeType: data?.storeType });
      return data?.nextPage || DELIVERY_ADDRESS;
    },
    backPage: '',
    onClose: (state, { formControl }) => {
      const { activeData, completedForm } = state;
      if (completedForm) {
        formControl.updateForm('delivery', { ...activeData.delivery });
      }
    }
  },
  [DELIVERY_ADDRESS]: {
    name: DELIVERY_ADDRESS,
    Component: DeliveryAddress,
    nextPage: (state, data, { saveRecentAddress, formControl, modalControl }) => {
      localStorage.setItem('dumpDlAddr', JSON.stringify(data));
      saveRecentAddress(data);
      formControl.updateForm('shippingAddress', data);
      const { modalPageStack } = state;
      if (modalPageStack.filter((x) => x === DELIVERY_ADDRESS).length > 1) {
        modalControl.popPage();
        return DELIVERY_ADDRESS;
      }
      return SELECT_STORE;
    },
    backPage: '',
    onClose: (state, { formControl }) => {
    }
  },
  [SELECT_STORE]: {
    name: SELECT_STORE,
    Component: StoreLocation,
    nextPage: (state, data, { formControl, modalControl }) => {
      formControl.updateForm('store', { slot: {} });
      formControl.updateForm('store', { ...data, storeId: data.id });
      modalControl.setStore();
      return SELECT_STORE;
    },
    backPage: '',
    onClose: (state, { formControl }) => {
    }
  },
  [DELIVERY_SLOT]: {
    name: DELIVERY_SLOT,
    Component: SlotBooking,
    nextPage: (state, data, { formData, formControl, modalControl }) => {
      const storeData = formData.store;
      if (data.nextPage) {
        if (data.nextPage !== SUMMARY_DELIVERY) {
          formControl.resumeFormRequest();
          return data.nextPage;
        }
      }
      modalControl.setLoading(true);
      formControl.updateForm('store', { ...storeData });
      if (state.requestReorder) {
        formControl.activeReorderForm(true);
      } else {
        formControl.changeSlot({ ...storeData, slot: data.slotData });
      }
      return DELIVERY_SLOT;
    },
    backPage: '',
    onClose: (state, { formControl }) => {
    }
  },
  [SUMMARY_DELIVERY]: {
    name: SUMMARY_DELIVERY,
    Component: DeliverySummary,
    nextPage: (state, data, { modalControl, formControl }) => {
      modalControl.savePage();
      formControl.resumeFormRequest();

      if (!formControl.isCompleteForm && data === SUMMARY_DELIVERY) {
        return DELIVERY_SLOT;
      }
      if (data === SUMMARY_DELIVERY) {
        modalControl.closeModal(true);
      }
      return data;
    },
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.savePage();
    }
  },
  [CHANGE_DELIVERY]: {
    name: CHANGE_DELIVERY,
    Component: ChangeDeliveryDialog,
    nextPage: (state, data, { formControl }) => {
      const { pendingPage } = state;
      if (formControl.formHadActive) {
        formControl.resumeFormRequest();
      }
      return pendingPage;
    },
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.popPage();
      modalControl.savePage();
    }
  },
  [CLEAR_CART]: {
    name: CLEAR_CART,
    Component: ClearCartDialog,
    nextPage: (state, data, { modalControl }) => {
      modalControl.setStore();
      return CLEAR_CART;
    },
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.popPage();
    }
  },
  [CUSTOMER_ADDRESS]: {
    name: CUSTOMER_ADDRESS,
    Component: CustomerSelectAddress,
    nextPage: (state, data, { formControl }) => {
      const { formData } = formControl;
      if (data.page === DELIVERY_ADDRESS) {
        formControl.updateForm('shippingAddress', {
          ...formData.shippingAddress,
          ...data.data,
        });
      } else if (data.page === SELECT_STORE) {
        if (state?.storeWithoutArea?.outOfServiceArea) {
          formControl.updateStoreWithoutArea({ shippingAddress: data.data });
        } else {
          formControl.updateForm('shippingAddress', { ...data.data });
        }
      }
      return data.page;
    },
    backPage: '',
    onClose: (state, { modalControl }) => {
      modalControl.closeModal();
    }
  },
  [CUSTOMER_ADDRESS_ALL]: {
    name: CUSTOMER_ADDRESS_ALL,
    Component: CustomerViewAllAddress,
    nextPage: (state, data, { formControl }) => {
      if (data.page === SELECT_STORE) {
        formControl.updateForm('shippingAddress', { ...data.data });
      }
      return data.page;
    },
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.popPage();
    }
  },
  [CUSTOMER_EDIT_ADDRESS]: {
    name: CUSTOMER_EDIT_ADDRESS,
    Component: CustomerManageAddress,
    nextPage: (state, data) => data.page,
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.popPage();
    }
  },
  [CUSTOMER_DELETE_ADDRESS]: {
    name: CUSTOMER_DELETE_ADDRESS,
    Component: CustomerDeleteAddress,
    nextPage: (state, data, { modalControl }) => {
      const { modalPageStack } = state;
      const toIdx = modalPageStack.indexOf(CUSTOMER_ADDRESS);
      if (toIdx > -1) {
        const newStack = modalPageStack.slice(0, toIdx + 1);
        modalControl.setPreStack(newStack, true);
      } else {
        modalControl.closeModal();
      }
      return CUSTOMER_DELETE_ADDRESS;
    },
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.popPage();
    }
  },
  [CUSTOMER_ADDRESS_DISCARD]: {
    name: CUSTOMER_ADDRESS_DISCARD,
    Component: CustomerDiscardAddress,
    nextPage: (state, data) => CUSTOMER_EDIT_ADDRESS,
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.popPage();
    }
  },
  [STORE_CLOSE_WARNING]: {
    name: STORE_CLOSE_WARNING,
    Component: StoreCloseWarningDialog,
    nextPage: (state, data, { modalControl }) => {
      modalControl.replacePage(DELIVERY_TYPE_MENU);
      return STORE_CLOSE_WARNING;
    },
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.closeModal(true);
    }
  },
  [SUMMARY_REORDER_DELIVERY]: {
    name: SUMMARY_REORDER_DELIVERY,
    Component: DeliveryReOrderSummary,
    nextPage: (state, data, { modalControl }) => data,
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.closeModal(true);
    }
  },
  [DIFFERENT_STORE_TYPE]: {
    name: DIFFERENT_STORE_TYPE,
    Component: DifferentStoreTypeDialog,
    nextPage: (state, data, { authentication, formControl, modalControl }) => {
      if (data?.defaultAddress) {
        formControl.updateForm('shippingAddress', data?.defaultAddress);
      }
      if (data?.adsStoreType === 'hyper') {
        formControl.updateForm('delivery', { deliveryType: '', deliveryMethod: '' });
        modalControl.setDisableGoFresh(true);
        modalControl.replacePage(DELIVERY_TYPE_MENU);
        return DELIVERY_TYPE_MENU;
      }
      if (data?.adsStoreType === 'go_fresh') {
        formControl.updateForm('delivery', { deliveryType: 'OD', deliveryMethod: 'HD' });
        if (data?.defaultAddress) {
          return SELECT_STORE;
        }
        modalControl.replacePage(authentication?.isGuest ? DELIVERY_ADDRESS : CUSTOMER_ADDRESS);
        return authentication?.isGuest ? DELIVERY_ADDRESS : CUSTOMER_ADDRESS;
      }
    },
    backPage: '',
    onClose: (state, { modalControl }) => {
      modalControl.setPendingDeliverySetting('');
      modalControl.closeModal(true);
    }
  },
  [CHANGE_STORE_DIALOG]: {
    name: CHANGE_STORE_DIALOG,
    Component: ChangeCartStoreDialog,
    nextPage: (state, data, { modalControl, formData }) => {
      modalControl.executeStoreChange();
      return CHANGE_STORE_DIALOG;
    },
    backPage: '',
    onClose: (state, { modalControl, formControl }) => {
      modalControl.setPendingDeliverySetting('');
      modalControl.closeModal(true);
      formControl.setRedirectTo('');
    }
  },
  [REORDER]: {
    name: REORDER,
    Component: ReorderDialog,
    nextPage: '',
    backPage: '',
    onClose: (state, { modalControl }) => {
      modalControl.closeModal(true);
    }
  },
  [REORDER_CLEAR_CART]: {
    name: REORDER_CLEAR_CART,
    Component: ReorderClearCartDialog,
    nextPage: '',
    backPage: '',
    onClose: (state, { modalControl }) => {
      modalControl.closeModal(true);
    }
  },
  [SUMMARY_CONTACT]: {
    name: SUMMARY_CONTACT,
    Component: SummaryContact,
    nextPage: (state, data, { formControl }) => {
      const { formData } = formControl;
      if (data.page === SELECT_STORE) {
        formControl.updateForm('shippingAddress', {
          ...formData.shippingAddress,
          ...data.data,
        });
      }
      return data.page;
    },
    backPage: '',
    onClose: (state, { modalControl }) => {
      modalControl.popPage();
    }
  },
  [STORE_WITH_OUT_AREA]: {
    name: STORE_WITH_OUT_AREA,
    Component: StoreWithoutArea,
    onClose: (state, { modalControl }) => {
      modalControl.popPage();
    }
  },
  [TERMS_AND_CONDITION_INSTALLMENT]: {
    name: TERMS_AND_CONDITION_INSTALLMENT,
    Component: TermsAndConditionInstallment,
    onClose: (state, { modalControl }) => {
      modalControl.popPage();
    }
  }
};
